import { render, staticRenderFns } from "./moreSelectPeople.vue?vue&type=template&id=65d17644&"
import script from "./moreSelectPeople.vue?vue&type=script&lang=js&"
export * from "./moreSelectPeople.vue?vue&type=script&lang=js&"
import style0 from "./moreSelectPeople.vue?vue&type=style&index=0&id=65d17644&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports